import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/live-or')({
  staticData: {
    title: 'pages.liveOr.title',
    description: 'pages.liveOr.description',
  },
  beforeLoad: async () => {
    const { useAuthStore } = await import(
      '../../features/auth/stores/auth.store'
    );
    const { getLandingPath } = await import(
      '../../shared/utils/landing-path'
    );
    const authStore = useAuthStore.getState();
    if (authStore.isLoading || !authStore.isInitialized) return;
    if (!authStore.isAuthenticated) throw redirect({ to: '/' });
    throw redirect({ to: getLandingPath(authStore.user) });
  },
  component: LiveORPage,
});

function LiveORPage() {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Live OR</h1>
        <p className="mt-2 text-gray-600">PeriTheatre Integration</p>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Live OR Page
        </h2>
        <p className="text-gray-600">
          This page will integrate with PeriTheatre for live OR functionality.
        </p>
      </div>
    </div>
  );
}
